import { useEffect, useMemo, useState } from "react"
import { Data, FieldType, Form, FormField, Modal, ModalId, option, useUIActions, useUIState } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { CashFund } from "../../../state/types"

type Props = {
    cashFunds: CashFund[]
    onSubmit: (data: Data) => void
}

export const CashFundItemFormModal = (props: Props) => {
    const { cashFunds, onSubmit } = props
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    const { closeModal } = useUIActions()

    useEffect(() => setKey(key + 1), [openedModal])

    const cashFundOptions = useMemo(() => cashFunds.map(cashFund => option(cashFund.id, cashFund.name)), [cashFunds])
    
    const fields: FormField[] = [
        {
            name: 'cashFundId',
            type: FieldType.TABLE,
            table: TableName.CASH_FUNDS,
            label: 'Caja',
            options: cashFundOptions
        }
    ]

    const handleSubmit = (data: Data) => {
        onSubmit(data)
        closeModal(ModalId.CASH_FUND_ITEM_FORM)
    }

    const handleCancel = () => closeModal(ModalId.CASH_FUND_ITEM_FORM)

    return (
        <Modal
            modalId={ModalId.CASH_FUND_ITEM_FORM}
            title="Agregar Caja"
            actions={[]}
        >
            <Form
                key={key}
                formId="cash-fund-item-form"
                fields={fields}
                createMode
                createLabel="Agregar"
                onSubmit={handleSubmit}
                onCancel={handleCancel}
            />
        </Modal>
    )
}
